import { MANUAL_TRANSLATION_AVAILABLE } from '~~/constants/pdpDetailSections';

export const hasManualTranslationsAlways = (country: string): boolean | undefined => {

  return MANUAL_TRANSLATION_AVAILABLE[country];

};
